var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"friend"},[_c('div',{staticClass:"friend-name",style:({
      background: _vm.friendGetList.length > 0 ? 'rgb(135, 135, 135,0.3)' : '',
      height: `${_vm.nameHeight}rem`,
      fontSize: `${_vm.fontSize}rem`,
      width: `${_vm.width}rem`,
      color: `${_vm.color}`,
    })},_vm._l((_vm.friendGetList),function(item,k){return _c('div',{key:k,class:['friend-name-item', _vm.isNeedTransition ? 'item-transition' : ''],style:({ top: `-${_vm.friendItemTopDistance}rem`, height: `${_vm.nameHeight}rem`, lineHeight: `${_vm.nameHeight}rem` })},[_vm._v(" "+_vm._s(item)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }